// extracted by mini-css-extract-plugin
export var actionText = "_o1-4";
export var container = "_o1-0";
export var leftSection = "_o1-1";
export var rightSection = "_o1-2";
export var settingsButton = "_o1-6";
export var settingsIcon = "_o1-7";
export var shortcut = "_o1-5";
export var shortcutGroup = "_o1-3";